import PropTypes from 'prop-types';
import React from 'react';

import { NavigationProvider } from '$contexts/navigation.jsx';
import Navigation from '$partials/navigation/navigation.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof innerPropTypes>} props
 */
const NavigationPageWrapperInner = ({ children }) => {
    return (
        <div className='w-full overflow-x-hidden bg-background'>
            <Navigation />
            {children}
        </div>
    );
};

/**
 * @param {PropTypes.InferProps<typeof outerPropTypes>} props
 */
const NavigationPageWrapperOuter = ({
    address,
    backgroundColour,
    children,
    links,
    textColour
}) => {
    const formattedLinks = links?.map((item) => {
        if (!item?.link) { return null; }
        const { title, url } = item.link;

        return {
            title,
            url
        };
    }).filter((item) => item !== null);

    return (
        <NavigationProvider
            address={address}
            backgroundColour={backgroundColour}
            links={formattedLinks}
            textColour={textColour}>
            <NavigationPageWrapperInner>
                {children}
            </NavigationPageWrapperInner>
        </NavigationProvider>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const innerPropTypes = { children: PropTypes.any };
NavigationPageWrapperInner.propTypes = innerPropTypes;

const outerPropTypes = {
    address: PropTypes.string,
    backgroundColour: PropTypes.string,
    children: PropTypes.any,
    links: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.shape({
            url: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            children: PropTypes.shape({
                edges: PropTypes.arrayOf(PropTypes.shape({
                    node: PropTypes.shape({
                        url: PropTypes.string.isRequired,
                        title: PropTypes.string.isRequired,
                    })
                }))
            })
        }).isRequired
    })).isRequired,
    textColour: PropTypes.string
};
NavigationPageWrapperOuter.propTypes = outerPropTypes;

export default NavigationPageWrapperOuter;
